export const headers = [
  { key: "1", label: "id_shift" },
  { key: "2", label: "title_shift" },
  { key: "3", label: "date_shift" },
  { key: "4", label: "capacity_shift" },
  { key: "5", label: "time_shift" },
  { key: "6", label: "edit_shift_shift" },
];
